var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPineconeV3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 186,
    viewBox: "0 0 212 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.1872 63.8176L105.2 54.7809C105.527 54.2898 105.408 53.6285 104.931 53.2817L95.9719 46.7691L85.5451 40.7724C85.0754 40.5022 84.479 40.6143 84.1395 41.0366L76.6501 50.3496L70.3564 59.6743C70.0178 60.1759 70.148 60.8567 70.6477 61.198L79.8217 67.464L90.0632 72.778C90.5087 73.0091 91.0541 72.9094 91.389 72.5357L99.0906 63.9424C99.1257 63.9032 99.158 63.8615 99.1872 63.8176Z",
    fill: "url(#paint0_linear_943_2236)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.382 112.404L126.661 96.2088C126.457 96.0636 126.181 96.0741 125.989 96.2344L100.985 117.098C100.559 117.454 100.597 118.113 101.072 118.401C104.45 120.449 116.214 127.107 125.096 126.262C134.751 125.343 146.598 115.811 149.429 113.425C149.754 113.151 149.728 112.65 149.382 112.404Z",
    fill: "url(#paint1_linear_943_2236)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7217 130.973L65.1313 107.711C65.2694 107.503 65.5308 107.414 65.7675 107.495L96.5877 118.014C97.1128 118.193 97.3132 118.822 96.9734 119.261C94.5531 122.384 85.9565 132.815 77.3611 135.208C68.0183 137.81 53.5419 133.156 50.0437 131.943C49.6428 131.804 49.4873 131.327 49.7217 130.973Z",
    fill: "url(#paint2_linear_943_2236)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.33 101.871L140.112 71.7247C139.964 71.2881 139.377 71.2164 139.128 71.6045L126.365 91.5234C126.093 91.9471 126.261 92.513 126.719 92.7203L149.209 102.887C149.866 103.185 150.562 102.554 150.33 101.871Z",
    fill: "url(#paint3_linear_943_2236)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3455 121.326L44.0828 89.5201C44.0645 89.0595 44.5871 88.7821 44.9584 89.0554L64.012 103.078C64.4172 103.376 64.4634 103.965 64.1096 104.323L46.7565 121.873C46.2492 122.386 45.3742 122.047 45.3455 121.326Z",
    fill: "url(#paint4_linear_943_2236)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.244 64.234C134.08 57.9511 121.557 45.5546 118.965 43.0442C118.718 42.8052 118.327 42.8558 118.138 43.1427C116.441 45.7225 109.092 56.7723 103.977 62.5852C99.4435 67.7368 99.2097 67.5924 99.1317 70.5237C98.9208 78.4479 117.167 85.1481 123.237 83.256C131.96 80.5366 136.253 69.6795 135.244 64.234Z",
    fill: "url(#paint5_linear_943_2236)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6446 80.6528C45.4803 74.3699 52.7296 58.3095 54.2499 55.037C54.3947 54.7254 54.7783 54.6323 55.0574 54.8326C57.5665 56.6328 68.3863 64.3158 75.2449 67.9099C81.3232 71.0949 81.4897 70.8764 82.6129 73.5851C85.6492 80.9076 71.0153 93.7009 64.6708 94.1092C55.5524 94.6961 47.6537 86.0983 46.6446 80.6528Z",
    fill: "url(#paint6_linear_943_2236)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.751 30.828C102.061 30.4531 99.4458 27.5181 97.4996 27.074C95.5534 26.63 95.0007 30.3531 93.7954 32.7894C92.59 35.2256 92.0237 36.0812 92.4479 38.3698C92.7722 40.1203 93.4629 40.9247 94.5242 42.31C95.5855 43.6954 97.3514 45.0728 99.2755 46.1569C101.663 47.5023 103.715 48.3203 106.351 47.4607C107.816 46.9831 108.205 46.7093 109.149 45.2326C110.658 42.8716 110.484 41.1399 109.661 38.4992C108.583 35.0388 102.751 30.828 102.751 30.828Z",
    fill: "url(#paint7_linear_943_2236)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4459 37.9406C64.9564 37.343 66.346 33.6659 68.0039 32.554C69.6617 31.4421 71.5118 34.72 73.51 36.5625C75.5083 38.4051 76.3436 39.001 76.7677 41.2896C77.0921 43.0401 76.7355 44.0385 76.2411 45.7122C75.7466 47.3858 74.5915 49.3045 73.1836 51.0061C71.4365 53.1177 69.8139 54.6167 67.0447 54.7588C65.5061 54.8377 65.0453 54.7213 63.6349 53.6809C61.3799 52.0175 60.9214 50.3386 60.7437 47.5783C60.5108 43.9611 64.4459 37.9406 64.4459 37.9406Z",
    fill: "url(#paint8_linear_943_2236)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9564 26.9784L81.059 19.4083C80.803 19.2125 80.4342 19.2778 80.261 19.5497L73.4738 30.2042C73.1472 30.7169 73.2983 31.3973 73.8113 31.7235L83.712 38.0188C83.9583 38.1754 84.284 38.1124 84.454 37.8752L91.182 28.4932C91.5283 28.0102 91.4284 27.3395 90.9564 26.9784Z",
    fill: "url(#paint9_linear_943_2236)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M122.146 89.176L91.8914 78.5636C91.7064 78.4987 91.5009 78.5372 91.352 78.6646L67.2721 99.25C66.7939 99.6588 66.9309 100.431 67.5206 100.65L97.486 111.796C97.6743 111.866 97.8859 111.828 98.0378 111.696L122.413 90.5781C122.892 90.1632 122.744 89.3857 122.146 89.176Z",
    fill: "url(#paint10_linear_943_2236)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.052 126.996C101.052 126.996 91.0962 133.433 78.2958 138.388C69.6405 141.738 59.5954 139.215 55.2568 136.86C54.0476 136.204 53.7071 136.879 53.8838 138.244C54.6856 144.435 58.1903 156.394 71.9174 163.676C90.8911 173.74 107.395 170.977 109.142 170.653L101.052 126.996Z",
    fill: "url(#paint11_linear_943_2236)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.043 126.939C101.043 126.939 112.645 129.381 126.371 129.421C135.652 129.447 144.125 123.492 147.332 119.739C148.226 118.693 148.786 119.202 149.11 120.539C150.58 126.606 151.593 139.027 141.387 150.744C127.279 166.938 110.881 170.273 109.134 170.597L101.043 126.939Z",
    fill: "url(#paint12_linear_943_2236)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1872 63.8176L105.2 54.7809C105.527 54.2898 105.408 53.6285 104.931 53.2817L95.9719 46.7691L85.5451 40.7724C85.0754 40.5022 84.479 40.6143 84.1395 41.0366L76.6501 50.3496L70.3564 59.6743C70.0178 60.1759 70.148 60.8567 70.6477 61.198L79.8217 67.464L90.0632 72.778C90.5087 73.0091 91.0541 72.9094 91.389 72.5357L99.0906 63.9424C99.1257 63.9032 99.158 63.8615 99.1872 63.8176Z",
    fill: "url(#paint13_linear_943_2236)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149.382 112.404L126.661 96.2088C126.457 96.0636 126.181 96.0741 125.989 96.2344L100.985 117.098C100.559 117.454 100.597 118.113 101.072 118.401C104.45 120.449 116.214 127.107 125.096 126.262C134.751 125.343 146.598 115.811 149.429 113.425C149.754 113.151 149.728 112.65 149.382 112.404Z",
    fill: "url(#paint14_linear_943_2236)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7217 130.973L65.1313 107.711C65.2694 107.503 65.5308 107.414 65.7675 107.495L96.5877 118.014C97.1128 118.193 97.3132 118.822 96.9734 119.261C94.5531 122.384 85.9565 132.815 77.3611 135.208C68.0183 137.81 53.5419 133.156 50.0437 131.943C49.6428 131.804 49.4873 131.327 49.7217 130.973Z",
    fill: "url(#paint15_linear_943_2236)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M150.33 101.871L140.112 71.7247C139.964 71.2881 139.377 71.2164 139.128 71.6045L126.365 91.5234C126.093 91.9471 126.261 92.513 126.719 92.7203L149.209 102.887C149.866 103.185 150.562 102.554 150.33 101.871Z",
    fill: "url(#paint16_linear_943_2236)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3455 121.326L44.0828 89.5201C44.0645 89.0595 44.5871 88.7821 44.9584 89.0554L64.012 103.078C64.4172 103.376 64.4634 103.965 64.1096 104.323L46.7565 121.873C46.2492 122.386 45.3742 122.047 45.3455 121.326Z",
    fill: "url(#paint17_linear_943_2236)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.244 64.234C134.08 57.9511 121.557 45.5546 118.965 43.0442C118.718 42.8052 118.327 42.8558 118.138 43.1427C116.441 45.7225 109.092 56.7723 103.977 62.5852C99.4435 67.7368 99.2097 67.5924 99.1317 70.5237C98.9208 78.4479 117.167 85.1481 123.237 83.256C131.96 80.5366 136.253 69.6795 135.244 64.234Z",
    fill: "url(#paint18_linear_943_2236)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6446 80.6528C45.4803 74.3699 52.7296 58.3095 54.2499 55.037C54.3947 54.7254 54.7783 54.6323 55.0574 54.8326C57.5665 56.6328 68.3863 64.3158 75.2449 67.9099C81.3232 71.0949 81.4897 70.8764 82.6129 73.5851C85.6492 80.9076 71.0153 93.7009 64.6708 94.1092C55.5524 94.6961 47.6537 86.0983 46.6446 80.6528Z",
    fill: "url(#paint19_linear_943_2236)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.751 30.828C102.061 30.4531 99.4458 27.5181 97.4996 27.074C95.5534 26.63 95.0007 30.3531 93.7954 32.7894C92.59 35.2256 92.0237 36.0812 92.4479 38.3698C92.7722 40.1203 93.4629 40.9247 94.5242 42.31C95.5855 43.6954 97.3514 45.0728 99.2755 46.1569C101.663 47.5023 103.715 48.3203 106.351 47.4607C107.816 46.9831 108.205 46.7093 109.149 45.2326C110.658 42.8716 110.484 41.1399 109.661 38.4992C108.583 35.0388 102.751 30.828 102.751 30.828Z",
    fill: "url(#paint20_linear_943_2236)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4459 37.9406C64.9564 37.343 66.346 33.6659 68.0039 32.554C69.6617 31.4421 71.5118 34.72 73.51 36.5625C75.5083 38.4051 76.3436 39.001 76.7677 41.2896C77.0921 43.0401 76.7355 44.0385 76.2411 45.7122C75.7466 47.3858 74.5915 49.3045 73.1836 51.0061C71.4365 53.1177 69.8139 54.6167 67.0447 54.7588C65.5061 54.8377 65.0453 54.7213 63.6349 53.6809C61.3799 52.0175 60.9214 50.3386 60.7437 47.5783C60.5108 43.9611 64.4459 37.9406 64.4459 37.9406Z",
    fill: "url(#paint21_linear_943_2236)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9564 26.9784L81.059 19.4083C80.803 19.2125 80.4342 19.2778 80.261 19.5497L73.4738 30.2042C73.1472 30.7169 73.2983 31.3973 73.8113 31.7235L83.712 38.0188C83.9583 38.1754 84.284 38.1124 84.454 37.8752L91.182 28.4932C91.5283 28.0102 91.4284 27.3395 90.9564 26.9784Z",
    fill: "url(#paint22_linear_943_2236)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.146 89.176L91.8914 78.5636C91.7064 78.4987 91.5009 78.5372 91.352 78.6646L67.2721 99.25C66.7939 99.6588 66.9309 100.431 67.5206 100.65L97.486 111.796C97.6743 111.866 97.8859 111.828 98.0378 111.696L122.413 90.5781C122.892 90.1632 122.744 89.3857 122.146 89.176Z",
    fill: "url(#paint23_linear_943_2236)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.052 126.996C101.052 126.996 91.0962 133.433 78.2958 138.388C69.6405 141.738 59.5954 139.215 55.2568 136.86C54.0476 136.204 53.7071 136.879 53.8838 138.244C54.6856 144.435 58.1903 156.394 71.9174 163.676C90.8911 173.74 107.395 170.977 109.142 170.653L101.052 126.996Z",
    fill: "url(#paint24_linear_943_2236)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.043 126.939C101.043 126.939 112.645 129.381 126.371 129.421C135.652 129.447 144.125 123.492 147.332 119.739C148.226 118.693 148.786 119.202 149.11 120.539C150.58 126.606 151.593 139.027 141.387 150.744C127.279 166.938 110.881 170.273 109.134 170.597L101.043 126.939Z",
    fill: "url(#paint25_linear_943_2236)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.3039,
    cy: 137.673,
    rx: 6.96936,
    ry: 6.92763,
    transform: "rotate(-10.4985 26.3039 137.673)",
    fill: "#5F4077"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.689,
    cy: 77.8438,
    rx: 6.96936,
    ry: 6.92763,
    transform: "rotate(-10.4985 190.689 77.8438)",
    fill: "#5F4077",
    fillOpacity: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.45,
    cy: 66.0193,
    rx: 6.96936,
    ry: 6.92763,
    transform: "rotate(-10.4985 181.45 66.0193)",
    fill: "#5F4077",
    fillOpacity: 0.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.758,
    cy: 57.4496,
    rx: 6.96936,
    ry: 6.92763,
    transform: "rotate(-10.4985 172.758 57.4496)",
    fill: "#5F4077",
    fillOpacity: 0.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.547,
    cy: 51.4757,
    rx: 6.96936,
    ry: 6.92763,
    transform: "rotate(-10.4985 164.547 51.4757)",
    fill: "#5F4077",
    fillOpacity: 0.7
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.053,
    cy: 48.6557,
    rx: 6.96936,
    ry: 6.92763,
    transform: "rotate(-10.4985 160.053 48.6557)",
    fill: "#5F4077"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M132.697 137.034C135.071 136.594 137.353 138.162 137.793 140.536C137.935 141.304 137.865 142.062 137.627 142.751C136.648 141.584 135.086 140.962 133.48 141.259C131.875 141.557 130.638 142.697 130.142 144.139C129.673 143.58 129.337 142.897 129.195 142.129C128.755 139.755 130.323 137.474 132.697 137.034Z",
    fill: "#E3C4FB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5958 147.43C78.9698 146.99 81.2513 148.558 81.6913 150.932C81.8335 151.7 81.7642 152.458 81.5268 153.148C80.5471 151.98 78.9846 151.358 77.3789 151.656C75.7733 151.953 74.5363 153.093 74.0398 154.534C73.5716 153.976 73.2358 153.293 73.0935 152.525C72.6536 150.151 74.2217 147.87 76.5958 147.43Z",
    fill: "#E3C4FB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_943_2236",
    x1: 84.6291,
    y1: 40.3217,
    x2: 90.7199,
    y2: 73.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_943_2236",
    x1: 121.66,
    y1: 96.8251,
    x2: 127.061,
    y2: 125.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_943_2236",
    x1: 70.021,
    y1: 106.495,
    x2: 75.4218,
    y2: 135.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_943_2236",
    x1: 133.538,
    y1: 71.792,
    x2: 139.827,
    y2: 105.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_943_2236",
    x1: 50.2444,
    y1: 87.2274,
    x2: 56.5334,
    y2: 121.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_943_2236",
    x1: 112.735,
    y1: 43.6624,
    x2: 120.185,
    y2: 83.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_943_2236",
    x1: 60.288,
    y1: 53.3817,
    x2: 67.7376,
    y2: 93.5822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_943_2236",
    x1: 98.9481,
    y1: 26.691,
    x2: 102.927,
    y2: 48.1628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_943_2236",
    x1: 66.5143,
    y1: 32.7154,
    x2: 70.4933,
    y2: 54.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_943_2236",
    x1: 80.4328,
    y1: 19.072,
    x2: 84.0008,
    y2: 38.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_943_2236",
    x1: 91.7928,
    y1: 78.4217,
    x2: 97.9917,
    y2: 111.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_943_2236",
    x1: 101.043,
    y1: 126.939,
    x2: 109.143,
    y2: 170.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_943_2236",
    x1: 101.043,
    y1: 126.939,
    x2: 109.143,
    y2: 170.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_943_2236",
    x1: 84.6291,
    y1: 40.3217,
    x2: 90.7199,
    y2: 73.1892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_943_2236",
    x1: 121.66,
    y1: 96.8251,
    x2: 127.061,
    y2: 125.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_943_2236",
    x1: 70.021,
    y1: 106.495,
    x2: 75.4218,
    y2: 135.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_943_2236",
    x1: 133.538,
    y1: 71.792,
    x2: 139.827,
    y2: 105.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_943_2236",
    x1: 50.2444,
    y1: 87.2274,
    x2: 56.5334,
    y2: 121.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_943_2236",
    x1: 112.735,
    y1: 43.6624,
    x2: 120.185,
    y2: 83.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_943_2236",
    x1: 60.288,
    y1: 53.3817,
    x2: 67.7376,
    y2: 93.5822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_943_2236",
    x1: 98.9481,
    y1: 26.691,
    x2: 102.927,
    y2: 48.1628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_943_2236",
    x1: 66.5143,
    y1: 32.7154,
    x2: 70.4933,
    y2: 54.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_943_2236",
    x1: 80.4328,
    y1: 19.072,
    x2: 84.0008,
    y2: 38.3257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_943_2236",
    x1: 91.7928,
    y1: 78.4217,
    x2: 97.9917,
    y2: 111.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_943_2236",
    x1: 101.043,
    y1: 126.939,
    x2: 109.143,
    y2: 170.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_943_2236",
    x1: 101.043,
    y1: 126.939,
    x2: 109.143,
    y2: 170.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4077"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPineconeV3);
export default __webpack_public_path__ + "static/media/pinecone_v3.19d3057050dfef92b611dc6cb31dd8f0.svg";
export { ForwardRef as ReactComponent };